/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { useReducer, useCallback } from "react";
import { useSelector } from "react-redux";

const initialState = {
  httpSending: false,
  httpError: null,
  httpData: null,
  reqType: null,
};

const httpReducer = (curHttpState, action) => {
  switch (action.type) {
    case "SEND":
      return {
        httpSending: true,
        httpError: null,
        httpData: null,
        reqType: action.reqType,
      };
    case "RESPONSE":
      return {
        ...curHttpState,
        httpSending: false,
        httpData: action.responseData,
      };
    case "ERROR":
      return { httpSending: false, httpError: action.errorMessage };
    case "CLEAR":
      return initialState;
    default:
      throw new Error("Should not be reached!");
  }
};

const useHttp = () => {
  const csrf = useSelector((state) => state.state_sec.csrf);

  const [httpState, dispatchHttp] = useReducer(httpReducer, initialState);

  const clear = useCallback(() => dispatchHttp({ type: "CLEAR" }), []);

  const sendReq = useCallback((url, method, body, reqType, dispatch = true) => {
    // console.log(`http-${reqType}: `, body);

    if (dispatch) dispatchHttp({ type: "SEND", reqType });

    fetch(`/prx/${url}`, {
      method: method,
      body: body,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "CSRF-Token": csrf,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (dispatch === true) {
          dispatchHttp({
            type: "RESPONSE",
            responseData: responseData,
          });
        }
      })
      .catch((error) => {
        dispatchHttp({
          type: "ERROR",
          errorMessage: error.message, //"Something went wrong!",
        });
      });
  }, []);

  const { httpSending, httpData, httpError, reqType } = httpState;
  return {
    httpSending,
    httpData,
    httpError,
    reqType,
    sendReq,
    clear,
  };
};

export default useHttp;
